/** Identity fields edited in Case Builder header; keep out of clinical field counts. */
export const IDENTITY_DETAIL_KEYS = new Set(['NACCID', 'otherCaseIdentifiers']);

function isFilled(value) {
    if (value == null) return false;
    if (typeof value === 'string') return value.trim().length > 0;
    if (Array.isArray(value)) return value.length > 0;
    if (typeof value === 'object') return Object.keys(value).length > 0;
    return true;
}

export function resolveClinicalSchema(doc, schemas = []) {
    if (doc?.schemaId && Array.isArray(schemas) && schemas.length) {
        const match = schemas.find((s) => String(s._id) === String(doc.schemaId));
        if (match) return match;
    }
    if (doc?.schema) {
        return { definition: doc.schema, name: doc.schema?.title || null };
    }
    if (Array.isArray(schemas) && schemas.length) {
        return schemas[schemas.length - 1];
    }
    return null;
}

/**
 * Count schema clinical detail fields filled on the case (excludes identity aliases).
 */
export function summarizeClinicalFields(doc, schemas = []) {
    const schema = resolveClinicalSchema(doc, schemas);
    const properties = schema?.definition?.properties || {};
    const keys = Object.keys(properties).filter((key) => !IDENTITY_DETAIL_KEYS.has(key));
    const details = doc?.details && typeof doc.details === 'object' ? doc.details : {};
    const filled = keys.filter((key) => isFilled(details[key])).length;
    const total = keys.length;
    return {
        schema,
        schemaName: schema?.name || schema?.version || schema?.definition?.title || null,
        total,
        filled,
        incomplete: Math.max(0, total - filled),
        percent: total ? Math.round((filled / total) * 100) : 0,
        hasSchema: total > 0,
    };
}
